// src/services/billing.js
// Lógica central de fatura

const MONTHS = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];

export function monthLabel(key) {
  if (!key) return '';
  const [y, m] = key.split('-');
  return MONTHS[parseInt(m) - 1] + '/' + y;
}

export function monthKey(dateStr) {
  return dateStr ? dateStr.slice(0, 7) : '';
}

export function addMonthsToKey(ym, n) {
  let [y, m] = ym.split('-').map(Number);
  m += n;
  while (m > 12) { m -= 12; y++; }
  return y + '-' + String(m).padStart(2, '0');
}

export function formatDate(d) {
  if (!d) return '';
  const [y, m, dy] = d.split('-');
  return `${dy}/${m}/${y}`;
}

export function formatCurrency(v) {
  return 'R$ ' + parseFloat(v).toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

/**
 * REGRA DE FATURA:
 * - Comprou até o dia de fechamento (inclusive) → fatura do mesmo mês
 * - Comprou após o fechamento → fatura do mês seguinte
 *
 * Exemplo: fechamento dia 10
 *   - Compra dia 05/abr → fatura ABR (paga 20/abr)
 *   - Compra dia 10/abr → fatura ABR (paga 20/abr)
 *   - Compra dia 11/abr → fatura MAI (paga 20/mai)
 */
export function getBillKey(card, purchaseDateStr) {
  if (!card || !purchaseDateStr) return monthKey(purchaseDateStr);
  const [py, pm, pd] = purchaseDateStr.split('-').map(Number);
  const closeDay = parseInt(card.closeDay);

  if (pd <= closeDay) {
    // Comprou até o fechamento → fatura deste mês
    return py + '-' + String(pm).padStart(2, '0');
  } else {
    // Comprou depois do fechamento → próxima fatura
    let nm = pm + 1, ny = py;
    if (nm > 12) { nm = 1; ny++; }
    return ny + '-' + String(nm).padStart(2, '0');
  }
}

export function getParcelBillKeys(card, purchaseDateStr, totalParcels) {
  const firstKey = getBillKey(card, purchaseDateStr);
  return Array.from({ length: totalParcels }, (_, i) => addMonthsToKey(firstKey, i));
}

export function getEntryBillKey(entry, cards) {
  if (entry.billKey) return entry.billKey;
  const card = cards.find(c => c.id === entry.cardId);
  return getBillKey(card, entry.date);
}

export function todayStr() {
  return new Date().toISOString().split('T')[0];
}

export function currentMonthKey() {
  return monthKey(todayStr());
}
